export default "/images/25250b72e756e13df23146255b8d8d02.avif";